import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function MeilleursTestsLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-[#222222] tablet:gap-1 tablet:text-base">
      <svg {...attributes} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.80999 21.6554C7.80999 24.3977 3.55469 24.3977 3.55469 21.6554L3.55469 6.12355C3.55469 3.38123 7.80999 3.38123 7.80999 6.12355L7.80999 21.6554Z"
          fill="#E77B64"
        />
        <path
          d="M14.725 26.7062C14.725 29.4485 10.4697 29.4485 10.4697 26.7062L10.4697 11.1743C10.4697 8.43201 14.725 8.43201 14.725 11.1743L14.725 26.7062Z"
          fill="#EE6CA5"
        />
        <path
          d="M21.6396 21.6554C21.6396 24.3977 17.3843 24.3977 17.3843 21.6554L17.3843 6.12355C17.3843 3.38123 21.6396 3.38123 21.6396 6.12355L21.6396 21.6554Z"
          fill="#65B12A"
        />
        <path
          d="M28.5546 26.7062C28.5546 29.4485 24.2993 29.4485 24.2993 26.7062L24.2993 11.6743C24.2993 8.93201 28.5546 8.93201 28.5546 11.6743L28.5546 26.7062Z"
          fill="#59ADCD"
        />
      </svg>

      <span>Meilleurs Tests</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
